import { useEffect } from 'react';

interface PageMetaOptions {
  title: string;
  favicon?: {
    ico?: string;
    png16?: string;
    png32?: string;
    png192?: string;
    png512?: string;
    apple?: string;
  };
}

/**
 * Хук для управления title и favicon страницы
 */
export const usePageMeta = ({ title, favicon }: PageMetaOptions) => {
  useEffect(() => {
    // Сохраняем оригинальный title
    const originalTitle = document.title;

    // Устанавливаем новый title
    document.title = title;

    // Функция для обновления или создания link элемента
    const updateOrCreateLink = (rel: string, href: string, sizes?: string) => {
      // Ищем существующий элемент
      let link = document.querySelector(`link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`) as HTMLLinkElement;

      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        if (sizes) link.sizes.value = sizes;
        document.head.appendChild(link);
      }

      link.href = href;
    };

    // Обновляем favicon если передан
    if (favicon) {
      if (favicon.ico) {
        updateOrCreateLink('icon', favicon.ico);
      }
      if (favicon.png16) {
        updateOrCreateLink('icon', favicon.png16, '16x16');
      }
      if (favicon.png32) {
        updateOrCreateLink('icon', favicon.png32, '32x32');
      }
      if (favicon.png192) {
        updateOrCreateLink('icon', favicon.png192, '192x192');
      }
      if (favicon.png512) {
        updateOrCreateLink('icon', favicon.png512, '512x512');
      }
      if (favicon.apple) {
        updateOrCreateLink('apple-touch-icon', favicon.apple);
      }
    }

    // Возвращаем оригинальный title при размонтировании
    return () => {
      document.title = originalTitle;
    };
  }, [title, favicon]);
};
